<template>
	<layer class="opt_more_g" name="role">
		<div class="box_opt_menu opt_menu_grade">
			<div class="menu_item" v-for="{code, name} in roles">
				<a href="javascript:" class="link_menu" @click="callback(code)">{{ name }}</a>
			</div>
		</div>
	</layer>
</template>

<script>
import Layer from './Layer.vue';

export default {
	components: {Layer},
	props: {
		roles: {
			type: Array,
			default: () => ([])
		},
		callback: {
			type: Function,
			default: () => null
		}
	}
}
</script>
